/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.26",
    versionName: "0.2.0-nightly.2025.8.26",
    versionChannel: "nightly",
    buildDate: "2025-08-26T00:08:58.939Z",
    commitHash: "d2a9e9730b22986e570b52960c23926fd491f408",
};
